
export const TableStyles = {
    headCells: {
        style: {
            backgroundColor: '#FAFBFB',
            fontWeight: 'bold',
        },
    },
};